export default __webpack_public_path__ + "locales/fr/ChangePhoneDialog.json?hash=e9cb0cab872acf980234c1b41312d8ad";